import { Location } from '@angular/common';
import { Component, OnDestroy, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { FRONTCHANNEL_LOGOUT_CHANNEL } from '@pages/system/frontchannel-logout';
import { reloadOnStaleChunk } from '@core/stale-chunk-reload';
import { NavIconSprite } from '@layout/shell/nav-icon/nav-icon-sprite';
import { NotificationStack } from '@core/notifications/notification-stack/notification-stack';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NavIconSprite, NotificationStack],
    // Спрайт иконок монтируется один раз на всё приложение: символы должны быть
    // в документе до любого `<use>`. Стопка уведомлений живёт вне shell, чтобы
    // её fixed-слой не зависел от раскладки.
    template: '<app-nav-icon-sprite /><router-outlet /><app-notification-stack />',
})
export class App implements OnDestroy {
    private readonly oidc = inject(OidcSecurityService);

    /** Front-channel logout пришёл в другую вкладку — выходим и в этой. */
    private readonly logoutChannel = new BroadcastChannel(FRONTCHANNEL_LOGOUT_CHANNEL);

    constructor() {
        // Вкладка открыта до выката: раздел из прежней сборки не загрузится — перезагружаем страницу (#29300).
        reloadOnStaleChunk(inject(Router), inject(Location));

        this.logoutChannel.addEventListener('message', (event: MessageEvent<{ type?: string }>) => {
            if (event.data?.type !== 'logout') return;
            this.oidc.logoffLocal();
            if (window.location.pathname !== '/frontchannel-logout') window.location.reload();
        });
    }

    ngOnDestroy(): void {
        this.logoutChannel.close();
    }
}
